<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="xjrwgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 我的待办
        </span>
        <normalNav :parent="self"></normalNav>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_xjrwgl" ref="searchForm_xjrwgl"></searchForm>
        </div>
        <div class="tableWrapper">
          <easyTable
            apiUrl="operation/risk/query_page"
            :parent="self"
            :config="config"
            :other="other"
            ref="table_xjrwgl"
          >
            <template slot="last">
              <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconcheck"
                    type="text"
                    size="small"
                    @click="look(scope.row)"
                    >详情</el-link
                  >
                  <more
                    :row="scope.row"
                    @update="$refs['table_xjrwgl'].getData"
                    v-if="scope.row.status != 9"
                  ></more>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>

        <el-dialog
          :visible.sync="lookDialogVisible"
          :title="title"
          :close-on-click-modal="false"
          class="editDialog systemAlarm"
          width="690px"
        >
          <div>
            <el-tabs v-model="tabActive">
              <el-tab-pane label="隐患详情" name="yhxq">
                <template v-if="!lookLoading">
                  <section class="list">
                    <ul>
                      <li>隐患类型：{{ oLook.riskTypeDesc }}</li>
                      <li>隐患等级：{{ oLook.riskLevelDesc }}</li>
                      <li>隐患编号：{{ oLook.flowId }}</li>
                      <li>
                        <p>
                          <span class="remark">图片:</span>
                          <template v-if="oLook.pic && oLook.pic.length > 0">
                            <el-image
                              style="width: 50px; height: 50px"
                              :src="url"
                              :preview-src-list="oLook.pic.split(';')"
                              v-for="(url, i) in oLook.pic.split(';')"
                              :key="i"
                            ></el-image>
                          </template>
                        </p>
                      </li>
                    </ul>
                    <ul>
                      <li>隐患内容：{{ oLook.content }}</li>
                      <li>隐患上报地点：{{ oLook.areaName }}</li>
                      <li>上报时间：{{ oLook.createTime }}</li>
                      <li>隐患状态：{{ oLook.statusDesc }}</li>
                    </ul>
                  </section>
                </template>
              </el-tab-pane>
              <el-tab-pane label="处理详情" name="clxq">
                <section v-if="!lookLoading">
                  <el-card
                    class="box-card"
                    v-for="({
                      id, //3
                      flowId, //20200407002
                      curDept, //5
                      curGroup, //null
                      curEmp, //null
                      opt, //1
                      optDesc, //隐患录入
                      pic, //null
                      nextDept, //null
                      nextGroup, //null
                      nextEmp, //null
                      remark, //2020年04月07日上报管理缺陷隐患
                      createTime, //2020-04-07 20:29:20
                      curDeptName, //后端开发
                      curEmpName, //null
                      nextDeptName, //null
                      nextEmpName, //null
                      riskLevel //null
                    },
                    i) in oLook.list"
                    :key="i"
                  >
                    <div slot="header" class="clearfix">
                      <span style="font-size:17px">{{ optDesc }}</span>
                    </div>

                    <template v-if="opt == 1">
                      <div class="text item">录入人:{{ curEmpName }}</div>
                      <div class="text item">隐患内容:{{ oLook.content }}</div>
                      <div class="text item">隐患地点:{{ oLook.areaName }}</div>
                      <div class="text item">审核部门:{{ curDeptName }}</div>
                      <div class="text item">录入时间:{{ createTime }}</div>
                    </template>

                    <template v-if="opt == 2">
                      <div class="text item">领取部门:{{ curDeptName }}</div>
                      <div class="text item">领取人员:{{ curEmpName }}</div>
                      <div class="text item">领取时间:{{ createTime }}</div>
                    </template>

                    <template v-if="opt == 3">
                      <div class="text item">当前部门:{{ curDeptName }}</div>
                      <div class="text item">操作人员:{{ curEmpName }}</div>
                      <div class="text item">被指派部门:{{ nextDeptName }}</div>
                      <div class="text item">被指派人员:{{ nextEmpName }}</div>
                      <div class="text item">指派时间:{{ createTime }}</div>
                    </template>

                    <template v-if="opt == 4">
                      <div class="text item">当前部门:{{ curDeptName }}</div>
                      <div class="text item">操作人员:{{ curEmpName }}</div>
                      <div class="text item">上报部门:{{ nextDeptName }}</div>
                      <div class="text item">上报说明:{{ remark }}</div>
                      <div class="text item">上报时间:{{ createTime }}</div>
                    </template>

                    <template v-if="opt == 5">
                      <div class="text item">当前部门:{{ curDeptName }}</div>
                      <div class="text item">操作人员:{{ curEmpName }}</div>
                      <div class="text item">下派部门:{{ nextDeptName }}</div>
                      <div class="text item">下派说明:{{ remark }}</div>
                      <div class="text item">下派时间:{{ createTime }}</div>
                    </template>

                    <template v-if="opt == 6">
                      <div class="text item">处理部门:{{ curDeptName }}</div>
                      <div class="text item">处理人员:{{ curEmpName }}</div>
                      <div class="text item">处理结果:{{ remark }}</div>
                      <div class="text item">处理时间:{{ createTime }}</div>
                    </template>

                    <template v-if="opt == 7">
                      <div class="text item">验收部门:{{ curDeptName }}</div>
                      <div class="text item">验收人:{{ curEmpName }}</div>
                      <div class="text item">验收结果:{{ remark }}</div>
                      <div class="text item">验收时间:{{ createTime }}</div>
                    </template>

                    <template v-if="opt == 8">
                      <div class="text item">当前部门:{{ curDeptName }}</div>
                      <div class="text item">操作人员:{{ curEmpName }}</div>
                      <div class="text item">驳回部门:{{ nextDeptName }}</div>
                      <div class="text item">驳回说明:{{ remark }}</div>
                      <div class="text item">驳回时间:{{ createTime }}</div>
                    </template>

                    <!-- <template v-if="opt==9">
                    <div class="text item">
                      验收人:{{curEmpName}}
                    </div>
                  </template> -->
                  </el-card>
                </section>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { yhzt, obj2urlsp } from 'utils'
  import more from './more'
  export default {
    data() {
      return {
        tabName: 'xjrwgl',
        tabActive: 'yhxq',
        show: false,
        title: '',
        form_xjrwgl: {},
        oLook: {},
        lookLoading: true,
        lookDialogVisible: false,
        lookForm: null,
        data: {},
        other: {
          handleDept: 0,
          statusType: 4
        },
        tableData: []
      }
    },
    computed: {
      ...mapGetters('Dictionary', ['yhlx']),
      self() {
        return this
      },
      items() {
        const that = this
        return [
          {
            type: 'input',
            prop: 'flowId',
            label: '隐患编号',
            placeholder: ''
          },
          {
            type: 'start',
            prop: 'startTime',
            label: '开始时间'
          },
          {
            type: 'end',
            prop: 'endTime',
            label: '结束时间'
          },
          {
            type: 'select',
            prop: 'riskType',
            label: '隐患类型',
            option: {
              option: that.yhlx
            }
          },
          {
            type: 'select',
            prop: 'status',
            label: '隐患状态',
            option: {
              option: yhzt
            }
          }
        ]
      },
      config() {
        return [
          {
            prop: 'flowId',
            label: '隐患编号'
          },
          {
            prop: 'createTime',
            label: '上报时间'
          },
          {
            prop: 'riskTypeDesc',
            label: '隐患类型'
          },
          {
            prop: 'subUserName',
            label: '上报人员'
          },
          {
            prop: 'areaName',
            label: '隐患地点'
          },
          {
            prop: 'content',
            label: '隐患内容'
          },
          {
            prop: 'curDeptName',
            label: '处理部门'
          },
          {
            prop: 'curEmpName',
            label: '处理人员'
          },
          {
            prop: 'riskLevelDesc',
            label: '隐患等级'
          },
          {
            prop: 'statusDesc',
            label: '隐患状态'
          }
        ]
      }
    },
    methods: {
      reset_xjrwgl(fn) {
        fn()
        this.form_xjrwgl = {}
      },
      search_xjrwgl(fn) {
        fn()
      },
      look(data) {
        this.oLook = data
        this.title = ''
        this.lookLoading = true
        this.lookDialogVisible = true
        this.$axiosget('operation/risk/flow', {
          params: {
            flowId: data.flowId
          }
        }).then(res => {
          this.oLook.list = res.data.data
          this.lookLoading = false
        })
        if (this.oLook.pic) {
          this.oLook.pic = data.pic
            ? data.pic.replaceAll(process.env.fileUrl, process.env.SSL_HOST + '/file/')
            : ''
        }
      },
      changeCompany(dept_id) {
        this.$set(this.form_xjrwgl, 'dept_id', dept_id)
      }
    },
    components: {
      normalNav: () => import('public/normalNav'),
      searchForm: () => import('public/searchForm'),
      easyTable: () => import('public/easyTable'),
      more
    },
    mounted() {}
  }
</script>

<style lang="less" scoped>
  .content {
    /deep/.systemAlarm {
      .el-tabs__content {
        font-size: 15px !important;
      }
      .el-tabs__item.is-top:nth-child(2) {
        padding-left: 20px;
      }
      .el-tabs__item.is-top:last-child {
        padding-right: 20px;
      }
      .el-tabs__item {
        color: #ccc;
        padding: 0 20px;
        height: 40px;
        box-sizing: border-box;
        line-height: 40px;
        display: inline-block;
        list-style: none;
        font-size: 14px;
        font-weight: 500;
      }
      .el-tabs__item.is-active {
        background-color: #253253;
        border-left: 1px solid #30426f;
      }
      #tab-first {
        padding-left: 20px;
      }
      #tab-second {
        padding-right: 20px;
      }

      .el-tabs__active-bar {
        background-image: linear-gradient(-90deg, #8652e7 0%, #35bfff 100%),
          linear-gradient(#35b9f7, #35b9f7);
      }
      .el-tabs__nav-wrap::after {
        background-color: #2d374d;
        /* height: 1px; */
      }
      /deep/ .el-tabs .loading {
        height: 300px;
        // background-image: url("./video.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        display: flex;
        justify-content: center;
        align-items: center;
        svg {
          width: 30px;
          height: 30px;
          animation: xuanzhuan 1.5s linear infinite;
        }
        @keyframes xuanzhuan {
          0% {
            -webkit-transform: rotate(0deg);
          }
          100% {
            -webkit-transform: rotate(360deg);
          }
        }
      }
    }
  }

  .remark {
    font-size: 14px;
    color: #cccccc;
    display: inline-block;
    vertical-align: top;
    padding-right: 15px;
  }

  .el-image + .el-image {
    margin-left: 15px;
  }

  .el-card__header {
    border-bottom: 1px solid #2d374d;
  }

  .editDialog .el-dialog__body {
    padding-top: 0;
  }
  .editDialog .list {
    width: 100%;
    margin-top: 17px;
    margin-bottom: 17px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
  }

  .editDialog .list > ul {
    flex: 1;
    padding-right: 20px;
  }

  .editDialog .list > ul + ul {
    flex: 1;
    padding-left: 20px;
  }

  .editDialog .list::before {
    content: '';
    width: 1px;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 50%;
  }

  .editDialog .list li {
    font-size: 14px;
    line-height: 32px;
    color: #cccccc;
  }

  .box-card {
    background: transparent;
    border: 1px solid #2d374d;
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/yinhuan/mine/index.vue